import React, { useState } from 'react';
import { Box, Button, TextField, Typography, MenuItem, Select, FormControl, InputLabel, CircularProgress, Alert } from '@mui/material';
import SideDrawer from '../Components/newcomponents/SideDrawer';
import Navbar from '../Components/LandingComponent/Navbar';
import { fetchReportData } from '../DatabaseApis/DBQuery';
import { generateExcel } from '../utils/generateExcel';

const ReportsPage = () => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [reportType, setReportType] = useState('projects');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleGenerateReport = async () => {
    setLoading(true);
    setError('');

    try {
      const data = await fetchReportData(reportType, startDate, endDate);

      if (!data || data.length === 0) {
        alert('No data available for the selected criteria.');
        return;
      }

      generateExcel(data, `${reportType}_report`, reportType);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <Box sx={{ display: 'flex', height: '80vh', overflow: 'hidden' }}>
      <Navbar handleDrawerToggle={handleDrawerToggle} />
      <SideDrawer open={drawerOpen} handleSidebarToggle={handleDrawerToggle} />

      <Box component="main" sx={{ flexGrow: 1, p: 3, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Box sx={{ width: '100%', maxWidth: 500, textAlign: 'center' , mt: '-50vh'}}>
          <Typography variant="h4" gutterBottom>Generate Reports</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3 }}>
            <TextField
              label="Start Date"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
            <TextField
              label="End Date"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
            <FormControl sx={{ width: '100%' }}>
              <InputLabel shrink={true} id="report-type-label">Report Type</InputLabel>
              <Select
                labelId="report-type-label"
                value={reportType}
                onChange={(e) => setReportType(e.target.value)}
                label="Report Type"
              >
                <MenuItem value="projects">Projects</MenuItem>
                <MenuItem value="cards">Cards</MenuItem>
                <MenuItem value="boards">Boards</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Button variant="contained" onClick={handleGenerateReport}>Generate Report</Button>
          {loading && <CircularProgress sx={{ mt: 3 }} />}
          {error && <Alert severity="error" sx={{ mt: 3 }}>{error}</Alert>}
        </Box>
      </Box>
    </Box>
  );
};

export default ReportsPage;
